import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({providedIn: 'root'})
export class InfoService extends BaseService {

  private url = 'api/info-status';  // URL to web api

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  /**
   * 已读全部
   * @returns {Observable<any|any>}
   */
  readAll():Observable<any> {
    const url = `${this.getUrl()}/read-all`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`readAll`)),
      catchError(this.handleError<any>(`headerQuery`))
    );
  }

  /**
   * 获取未读消息数量
   * @returns {Observable<any|any>}
   */
  getUnreadCount():Observable<Number> {
    const url = `${this.getUrl()}/get-unread-count`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`get-unread-count`)),
      catchError(this.handleError<any>(`get-unread-count`))
    );
  }

  /**
   * 测试消息
   * @returns {Observable<any|any>}
   */
  testSend():Observable<any> {
    const url = `${this.getUrl()}/test-send`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`readAll`)),
      catchError(this.handleError<any>(`headerQuery`))
    );
  }

  /**
   * 读消息
   * @param id
   * @returns {Observable<any|any>}
   */
  view(id):Observable<any> {
    const url = `${this.getUrl()}/view-info`;
    return this.http.get<any>(url, {
      params: {id: id}
    }).pipe(
      tap(_ => this.log(`headerQuery`)),
      catchError(this.handleError<any>(`headerQuery`))
    );
  }
}

